// Core world/simulation constants. Pure data — safe to import anywhere.

export const CHUNK_SIZE_X = 16;
export const CHUNK_SIZE_Z = 16;
export const WORLD_HEIGHT = 128;

/** Sea level: water fills up to (and including) this Y. */
export const SEA_LEVEL = 40;

/** Simulation runs at a fixed timestep, independent of render frame rate. */
export const TICK_RATE = 60;
export const TICK_DT = 1 / TICK_RATE;

/** Player physical dimensions (in blocks) and eye height. */
export const PLAYER_WIDTH = 0.6;
export const PLAYER_HEIGHT = 1.8;
export const PLAYER_EYE = 1.62;

/** Movement tuning, roughly Minecraft-like. */
export const WALK_SPEED = 4.3; // blocks/second
export const GRAVITY = 28; // blocks/second^2
export const JUMP_SPEED = 8.4; // gives ~1.25 block jump
export const WATER_DRAG = 0.5;

/** How far (blocks) the player can reach to mine or place. */
export const REACH = 5;

/** Length of one full day/night cycle in seconds of real time. */
export const DAY_LENGTH = 600;
